import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const Layout = () => (
    <div className="wrapper">
      <Header />
      <Sidebar />
      <div className="content-wrapper">
        <Outlet /> 
      </div>
      <Footer />
    </div>
);

export default Layout;
